import * as React from 'react';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';
import { useAccountPositionsSAccLml2Description } from '../../hooks';

export const AccountsPositionsSAccLml2Description = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionsSAccLml2Description();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      loadingValue="--- ------------ ----- -- -,--% --/--/----"
    />
  );
};
